/* eslint-disable complexity */
import { getGenderPathPrefix } from '../utils/getGenderPathPrefix'
import { SearchConditions } from './types'

/**
 * Build url path and query string
 * @param conditions SearchConditions
 * @returns {string} url path and query string
 */
export const buildItemListUrl = (conditions: SearchConditions) => {
  const params = new URLSearchParams(conditions.additionalQueries)
  const genderPathPrefix = getGenderPathPrefix(conditions.gender ?? 'all')
  if (conditions.brand) params.set('brand_id', conditions.brand.id.toString())
  if (conditions.category?.id)
    params.set('type_category_id', conditions.category.id.toString())
  if (conditions.category?.child?.id)
    params.set('category_id', conditions.category.child.id.toString())
  if (conditions?.colorGroupId)
    params.set('color_group_id', conditions.colorGroupId.toString())
  if (conditions.sort === 'new') params.set('type_id', '2')
  if (conditions.searchWord) params.set('search_word', conditions.searchWord)
  if (conditions.linkedToCoordinate) params.set('coordinate_presence', '1')

  const paramsString = params.toString()
  return `/${genderPathPrefix}item/${paramsString ? `?${paramsString}` : ''}`
}
